import { useEffect } from "react";

// Small utility to set/replace meta tags in document.head at runtime.
// - attr: "name" or "property"
const setMeta = (attr, key, value) => {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * useOpenGraph({ title, description, url, image, type })
 *
 * Dynamically updates OG + Twitter meta on route change. Note: WhatsApp and
 * Facebook do NOT execute JavaScript when they scrape a link, so these dynamic
 * tags primarily benefit LinkedIn, Slack, Discord, Google, and Facebook's
 * post-JS "Scrape Again" flow. For guaranteed WhatsApp previews per article,
 * server-side rendering (SSR) would be required.
 */
export const useOpenGraph = ({
  title,
  description,
  url,
  image,
  type = "website",
  imageWidth = 1200,
  imageHeight = 630,
  imageAlt,
}) => {
  useEffect(() => {
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (url) {
      setMeta("property", "og:url", url);
      setCanonical(url);
    }
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("property", "og:image:width", String(imageWidth));
      setMeta("property", "og:image:height", String(imageHeight));
      if (imageAlt) setMeta("property", "og:image:alt", imageAlt);
      setMeta("name", "twitter:image", image);
    }
    setMeta("property", "og:type", type);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("property", "og:site_name", "Mumbai Elite Diagnostics");
  }, [title, description, url, image, type, imageWidth, imageHeight, imageAlt]);
};

export default useOpenGraph;
